import MagnifyingGlassLoopIcon from './assets/MagnifyingGlassLoopIcon';
import { XStylesSettings } from '@shared/types/types';
import EyeSlashIcon from './assets/EyeSlashIcon';
import useInputLogic from '../lib/useInputLogic';
import XMarksCross from './assets/XMarksCross';
import { InputProps } from '../model/types';
import * as stylex from '@stylexjs/stylex';
import EyeIcon from './assets/EyeIcon';
import { LockClosedIcon } from '@shared/assets/icons';
import { forwardRef } from 'react';
import { styles } from './styles';

const Input = forwardRef((props: InputProps) => {
  const {
    size = 'medium',
    isDisabled = false,
    placeholder,
    type = 'text',
    status = 'default',
    labelText,
    inputMessage,
    readonly = false,
    value,
    changeFunction,
    ref,
    settings,
  } = props;

  const { handleChange, isViewPassword, setIsViewPassword } = useInputLogic(props);

  return (
    <div
      data-testid="input-container"
      {...stylex.props(
        styles.container,
        styles[size],
        isDisabled && styles.containerDisabled,
        settings as XStylesSettings
      )}
    >
      {(labelText || readonly) && (
        <div data-testid="label-txt" {...stylex.props(styles.labelText(size), isDisabled && styles.isDisabled)}>
          {labelText || <span aria-hidden="true" />}
          {readonly && <LockClosedIcon size="20" />}
        </div>
      )}

      <input
        {...stylex.props(
          styles.base,
          styles.inputText(size),
          styles.size,
          styles[status],
          isDisabled && styles.isDisabled,
          readonly && styles.isReadonly
        )}
        ref={ref}
        {...(type === 'password' && !isViewPassword ? { type: 'password' } : { type: 'text' })}
        onChange={(e) => handleChange(e)}
        disabled={isDisabled}
        value={value}
        readOnly={readonly}
        placeholder={placeholder}
        autoComplete={type === 'password' ? 'new-password' : 'off'}
      ></input>
      {inputMessage && !isDisabled && status !== 'default' ? (
        <div data-testid="input-msg" {...stylex.props(styles.inputMsgSize(size), styles.inputMsgColor(status))}>
          {inputMessage}
        </div>
      ) : (
        ''
      )}
      {type === 'search' ? (
        <div data-testid="search-icons" {...stylex.props(styles.searchIcons(size))}>
          <div>
            <MagnifyingGlassLoopIcon size={size} />
          </div>
          <div
            data-testid="x-marks-icon"
            {...stylex.props(styles.XMarksIcon)}
            onClick={() => changeFunction && changeFunction('')}
          >
            <XMarksCross size={size} />
          </div>
        </div>
      ) : (
        ''
      )}
      {type === 'password' ? (
        <>
          {isViewPassword ? (
            <div data-testid="eye" {...stylex.props(styles.eyeIcon(size))} onClick={() => setIsViewPassword(false)}>
              <EyeIcon size={size} />
            </div>
          ) : (
            <div
              data-testid="eye-slash"
              {...stylex.props(styles.eyeIcon(size))}
              onClick={() => setIsViewPassword(true)}
            >
              <EyeSlashIcon size={size} />
            </div>
          )}
        </>
      ) : (
        ''
      )}
    </div>
  );
});

export default Input;
